import React from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
var ButtonResponseStep = function ButtonResponseStep(_ref) {
  var content = _ref.content,
    onNextClick = _ref.onNextClick,
    points = _ref.points,
    isDesktop = _ref.isDesktop;
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--button",
    isDesktop: isDesktop
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__text"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: content.StepHeaderIcon,
    header: content.StepHeaderTitle
  }), /*#__PURE__*/React.createElement("p", {
    className: "step__title"
  }, content.Heading)), /*#__PURE__*/React.createElement("div", {
    className: "step__buttons"
  }, content.ResponseOptions.map(function (responseOption, index) {
    return /*#__PURE__*/React.createElement("button", {
      className: "step-button like-orange-button-large"
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: index,
      onClick: function onClick(e) {
        e.preventDefault();
        onNextClick({
          points: responseOption.TriggerPoints ? points : 0
        });
      }
    }, responseOption.Label);
  })));
};
ButtonResponseStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  onNextClick: PropTypes.func.isRequired,
  points: PropTypes.number.isRequired,
  isDesktop: PropTypes.bool
};
ButtonResponseStep.defaultProps = {
  isDesktop: false
};
export default ButtonResponseStep;